"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllegroNetNamingStrategy = void 0;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const NetCombobulator_1 = require("../../../NetCombobulation/NetCombobulator");
const NetNamingRuleChain_1 = require("../../../NetCombobulation/NetNamingRuleChain");
const IndividualGroupingRule_1 = require("../../../NetCombobulation/IndividualGroupingRule");
const AllegroPropagateXconNameRule_1 = require("./rules/AllegroPropagateXconNameRule");
const AllegroUnconnectedPinNamingRule_1 = require("./rules/AllegroUnconnectedPinNamingRule");
class AllegroNetNamingStrategy {
    constructor() {
        this.ruleChain = new NetNamingRuleChain_1.NetNamingRuleChain();
        this.ruleChain.add(new IndividualGroupingRule_1.IndividualGroupingRule());
        this.ruleChain.add(new AllegroPropagateXconNameRule_1.AllegroPropagateXconNameRule());
        this.ruleChain.add(new AllegroUnconnectedPinNamingRule_1.AllegroUnconnectedPinNamingRule());
    }
    transformNetName(netObject, _instance) {
        return (netObject.label?.strategyMetadata?.xconNetName ??
            netObject.wire?.strategyMetadata?.xconNetName ??
            netObject.connection?.connection.appliesNetName?.strategyMetadata?.xconNetName);
    }
    canLabelTypeNameNets(_labelType, _instance) {
        return true;
    }
    resolveNetName(net, _instance) {
        for (const conn of net.connections) {
            const name = conn.connection.appliesNetName?.strategyMetadata?.xconNetName;
            if (name !== undefined && name.length > 0) {
                return name;
            }
        }
        for (const label of net.labels) {
            const name = label.strategyMetadata?.xconNetName;
            if (name !== undefined && name.length > 0) {
                return name;
            }
        }
        for (const wire of net.wires) {
            const name = wire.strategyMetadata?.xconNetName;
            if (name !== undefined && name.length > 0) {
                return name;
            }
        }
        return net.name.valueOf();
    }
    resolvePhysicalNetNames(hierarchy) {
        return this.ruleChain.execute(hierarchy);
    }
    createVirtualRootHierarchy(roots) {
        if (roots.length === 0) {
            throw new Error('createVirtualRootHierarchy requires at least one root');
        }
        const firstChildInstance = roots[0].instance;
        const virtualInstance = {
            pathUniqueId: '__allegro_virtual_root__',
            hierarchyEntry: firstChildInstance.hierarchyEntry,
            path: [],
            children: roots.map((c) => c.instance),
            numInstances: 1,
            totalSheetInstances: 1,
            instanceIndex: 0,
            sheetSymbol: undefined,
            netRefCtx: new sigma_engine_shared_1.NetRefCtx(),
        };
        const emptyCombobulator = new NetCombobulator_1.NetCombobulator(new sigma_engine_shared_1.NetRefCtx(), this, virtualInstance, { pointRoundingPrecision: 0.1 });
        return {
            pathUniqueId: '__allegro_virtual_root__',
            hierarchyDepth: -1,
            instance: virtualInstance,
            combobulator: emptyCombobulator,
            children: roots,
        };
    }
}
exports.AllegroNetNamingStrategy = AllegroNetNamingStrategy;
//# sourceMappingURL=AllegroNetNamingStrategy.js.map